var map = {
	"./Alerts & feedback/alert-circle.svg": 43970,
	"./Alerts & feedback/alert-hexagon.svg": 84006,
	"./Alerts & feedback/alert-octagon.svg": 70467,
	"./Alerts & feedback/alert-square.svg": 38887,
	"./Alerts & feedback/alert-triangle.svg": 73082,
	"./Alerts & feedback/announcement-02.svg": 5663,
	"./Alerts & feedback/announcement-03.svg": 67726,
	"./Alerts & feedback/bell-03.svg": 44412,
	"./Alerts & feedback/bell-04.svg": 72067,
	"./Alerts & feedback/bell-ringing-03.svg": 92875,
	"./Alerts & feedback/bell-ringing-04.svg": 30724,
	"./Alerts & feedback/notification-box.svg": 96580,
	"./Alerts & feedback/notification-message.svg": 25542,
	"./Alerts & feedback/notification-text.svg": 17508,
	"./Alerts & feedback/thumbs-down.svg": 10035,
	"./Alerts & feedback/thumbs-up.svg": 70316,
	"./Arrows/arrow-block-down.svg": 57739,
	"./Arrows/arrow-block-left.svg": 24716,
	"./Arrows/arrow-block-right.svg": 58323,
	"./Arrows/arrow-block-up.svg": 16036,
	"./Arrows/arrow-circle-down-left.svg": 22766,
	"./Arrows/arrow-circle-down-right.svg": 25485,
	"./Arrows/arrow-circle-down.svg": 95876,
	"./Arrows/arrow-circle-left.svg": 92035,
	"./Arrows/arrow-circle-right.svg": 52678,
	"./Arrows/arrow-circle-up-left.svg": 49443,
	"./Arrows/arrow-circle-up-right.svg": 41574,
	"./Arrows/arrow-circle-up.svg": 96255,
	"./Arrows/arrow-narrow-down-left.svg": 67687,
	"./Arrows/arrow-narrow-down-right.svg": 68066,
	"./Arrows/arrow-narrow-down.svg": 26003,
	"./Arrows/arrow-narrow-left.svg": 48548,
	"./Arrows/arrow-narrow-right.svg": 31563,
	"./Arrows/arrow-narrow-up-left.svg": 63814,
	"./Arrows/arrow-narrow-up-right.svg": 82373,
	"./Arrows/arrow-narrow-up.svg": 34668,
	"./Arrows/arrow-square-down-left.svg": 57259,
	"./Arrows/arrow-square-down-right.svg": 61518,
	"./Arrows/arrow-square-down.svg": 18839,
	"./Arrows/arrow-square-left.svg": 30696,
	"./Arrows/arrow-square-right.svg": 83607,
	"./Arrows/arrow-square-up-left.svg": 53298,
	"./Arrows/arrow-square-up-right.svg": 16361,
	"./Arrows/arrow-square-up.svg": 45864,
	"./Arrows/arrows-triangle.svg": 40514,
	"./Arrows/chevron-down-double.svg": 54453,
	"./Arrows/chevron-down.svg": 15089,
	"./Arrows/chevron-left-double.svg": 75572,
	"./Arrows/chevron-left.svg": 29706,
	"./Arrows/chevron-right-double.svg": 98725,
	"./Arrows/chevron-right.svg": 83329,
	"./Arrows/chevron-selector-horizontal.svg": 41791,
	"./Arrows/chevron-selector-vertical.svg": 7069,
	"./Arrows/chevron-up-double.svg": 9520,
	"./Arrows/chevron-up.svg": 94190,
	"./Arrows/corner-down-left.svg": 32565,
	"./Arrows/corner-down-right.svg": 85688,
	"./Arrows/corner-left-down.svg": 2227,
	"./Arrows/corner-left-up.svg": 83084,
	"./Arrows/corner-right-down.svg": 17646,
	"./Arrows/corner-right-up.svg": 19429,
	"./Arrows/corner-up-left.svg": 80248,
	"./Arrows/corner-up-right.svg": 34471,
	"./Arrows/expand-01.svg": 5589,
	"./Arrows/expand-06.svg": 33962,
	"./Arrows/flip-forward.svg": 38570,
	"./Arrows/infinity.svg": 55587,
	"./Arrows/refresh-cw-01.svg": 93217,
	"./Arrows/refresh-cw-02.svg": 11474,
	"./Arrows/refresh-cw-05.svg": 45405,
	"./Arrows/reverse-left.svg": 80147,
	"./Arrows/reverse-right.svg": 93110,
	"./Arrows/switch-horizontal-01.svg": 21176,
	"./Arrows/switch-horizontal-02.svg": 71915,
	"./Arrows/switch-vertical-01.svg": 19578,
	"./Arrows/switch-vertical-02.svg": 87689,
	"./AudioEye/accessible-human.svg": 93044,
	"./Charts/bar-chart-01.svg": 40960,
	"./Charts/bar-chart-02.svg": 85619,
	"./Charts/bar-chart-03.svg": 98242,
	"./Charts/bar-chart-07.svg": 27438,
	"./Charts/bar-chart-08.svg": 57225,
	"./Charts/bar-chart-09.svg": 31864,
	"./Charts/bar-chart-10.svg": 26150,
	"./Charts/bar-chart-11.svg": 13687,
	"./Charts/bar-chart-12.svg": 70564,
	"./Charts/bar-chart-square-01.svg": 67792,
	"./Charts/bar-chart-square-02.svg": 57187,
	"./Charts/bar-chart-square-03.svg": 53874,
	"./Charts/bar-line-chart.svg": 6013,
	"./Charts/chart-breakout-circle.svg": 26747,
	"./Charts/chart-breakout-square.svg": 826,
	"./Charts/horizontal-bar-chart-01.svg": 47529,
	"./Charts/horizontal-bar-chart-02.svg": 79418,
	"./Charts/horizontal-bar-chart-03.svg": 94027,
	"./Charts/line-chart-down-01.svg": 6458,
	"./Charts/line-chart-down-02.svg": 74569,
	"./Charts/line-chart-down-03.svg": 70328,
	"./Charts/line-chart-up-01.svg": 2415,
	"./Charts/line-chart-up-02.svg": 92,
	"./Charts/line-chart-up-03.svg": 28637,
	"./Charts/pie-chart-02.svg": 48888,
	"./Charts/pie-chart-03.svg": 83753,
	"./Charts/pie-chart-04.svg": 81158,
	"./Charts/presentation-chart-01.svg": 64953,
	"./Charts/trend-down-01.svg": 54438,
	"./Charts/trend-down-02.svg": 90661,
	"./Charts/trend-up-01.svg": 29811,
	"./Charts/trend-up-02.svg": 58912,
	"./Communication/annotation-alert.svg": 59747,
	"./Communication/annotation-check.svg": 49093,
	"./Communication/annotation-dots.svg": 83200,
	"./Communication/annotation-heart.svg": 84753,
	"./Communication/annotation-info.svg": 41327,
	"./Communication/annotation-plus.svg": 48671,
	"./Communication/annotation-question.svg": 40175,
	"./Communication/annotation-x.svg": 21669,
	"./Communication/annotation.svg": 99318,
	"./Communication/inbox-01.svg": 51813,
	"./Communication/mail-02.svg": 82931,
	"./Communication/mail-05.svg": 98892,
	"./Communication/message-alert-square.svg": 72433,
	"./Communication/message-chat-square.svg": 14659,
	"./Communication/message-check-square.svg": 64751,
	"./Communication/message-dots-square.svg": 34590,
	"./Communication/message-heart-square.svg": 74507,
	"./Communication/message-notification-square.svg": 91878,
	"./Communication/message-plus-square.svg": 58621,
	"./Communication/message-question-square.svg": 13581,
	"./Communication/message-smile-square.svg": 29415,
	"./Communication/message-square-01.svg": 50010,
	"./Communication/message-square-02.svg": 94825,
	"./Communication/message-text-square-01.svg": 65198,
	"./Communication/message-text-square-02.svg": 97197,
	"./Communication/message-x-square.svg": 75839,
	"./Communication/phone-call-01.svg": 87800,
	"./Communication/phone.svg": 59427,
	"./Communication/send-01.svg": 53601,
	"./Communication/send-03.svg": 86499,
	"./Development/brackets-check.svg": 64728,
	"./Development/brackets-ellipses.svg": 5493,
	"./Development/brackets-x.svg": 73704,
	"./Development/brackets.svg": 19527,
	"./Development/browser.svg": 64056,
	"./Development/code-01.svg": 37993,
	"./Development/code-02.svg": 12410,
	"./Development/code-browser.svg": 7840,
	"./Development/code-circle-01.svg": 71912,
	"./Development/code-circle-03.svg": 19082,
	"./Development/code-square-01.svg": 29803,
	"./Development/container.svg": 16357,
	"./Development/cpu-chip-01.svg": 62755,
	"./Development/cpu-chip-02.svg": 96656,
	"./Development/data.svg": 98104,
	"./Development/database-01.svg": 44129,
	"./Development/database-02.svg": 62386,
	"./Development/database-03.svg": 95427,
	"./Development/dataflow-01.svg": 72252,
	"./Development/dataflow-02.svg": 51279,
	"./Development/dataflow-03.svg": 88702,
	"./Development/dataflow-04.svg": 48609,
	"./Development/file-code-01.svg": 33812,
	"./Development/file-code-02.svg": 82023,
	"./Development/folder-code.svg": 88638,
	"./Development/git-branch-01.svg": 20987,
	"./Development/git-commit.svg": 30538,
	"./Development/git-merge.svg": 3367,
	"./Development/package.svg": 8672,
	"./Development/puzzle-piece-01.svg": 31391,
	"./Development/puzzle-piece-02.svg": 76044,
	"./Development/server-01.svg": 65695,
	"./Development/server-02.svg": 86668,
	"./Development/server-03.svg": 85613,
	"./Development/server-04.svg": 15394,
	"./Development/server-05.svg": 20563,
	"./Development/terminal-browser.svg": 30191,
	"./Development/terminal-square.svg": 31800,
	"./Development/terminal.svg": 40344,
	"./Editor/align-center.svg": 84907,
	"./Editor/align-justify.svg": 32704,
	"./Editor/align-left.svg": 3507,
	"./Editor/align-right.svg": 97750,
	"./Editor/attachment-01.svg": 85145,
	"./Editor/attachment-02.svg": 40746,
	"./Editor/bezier-curve-01.svg": 55917,
	"./Editor/bold-01.svg": 11967,
	"./Editor/bold-02.svg": 40268,
	"./Editor/brush-01.svg": 72708,
	"./Editor/brush-02.svg": 15831,
	"./Editor/brush-03.svg": 28294,
	"./Editor/circle-cut.svg": 30635,
	"./Editor/code-snippet-01.svg": 16329,
	"./Editor/code-snippet-02.svg": 1242,
	"./Editor/colors.svg": 46404,
	"./Editor/command.svg": 70939,
	"./Editor/contrast-01.svg": 82326,
	"./Editor/contrast-02.svg": 54197,
	"./Editor/contrast-03.svg": 81588,
	"./Editor/crop-01.svg": 77394,
	"./Editor/crop-02.svg": 82433,
	"./Editor/cursor-02.svg": 97765,
	"./Editor/cursor-04.svg": 51275,
	"./Editor/cursor-box.svg": 5310,
	"./Editor/cursor-click-01.svg": 73811,
	"./Editor/cursor-click-02.svg": 2912,
	"./Editor/delete.svg": 79217,
	"./Editor/dotpoints-01.svg": 61400,
	"./Editor/dotpoints-02.svg": 235,
	"./Editor/drop.svg": 95967,
	"./Editor/dropper.svg": 63268,
	"./Editor/eraser.svg": 90888,
	"./Editor/feather.svg": 5725,
	"./Editor/figma.svg": 7612,
	"./Editor/framer.svg": 49727,
	"./Editor/hand.svg": 95763,
	"./Editor/heading-01.svg": 99650,
	"./Editor/heading-02.svg": 40401,
	"./Editor/image-indent-left.svg": 91220,
	"./Editor/image-indent-right.svg": 40219,
	"./Editor/italic-01.svg": 27668,
	"./Editor/italic-02.svg": 15527,
	"./Editor/magic-wand-01.svg": 29220,
	"./Editor/magic-wand-02.svg": 72343,
	"./Editor/move.svg": 20879,
	"./Editor/palette.svg": 96725,
	"./Editor/pen-tool-02.svg": 63115,
	"./Editor/pen-tool-minus.svg": 82995,
	"./Editor/pen-tool-plus.svg": 72981,
	"./Editor/pencil-01.svg": 44785,
	"./Editor/pencil-02.svg": 24418,
	"./Editor/pencil-line.svg": 52246,
	"./Editor/perspective-01.svg": 56254,
	"./Editor/perspective-02.svg": 2525,
	"./Editor/reflect-01.svg": 88033,
	"./Editor/reflect-02.svg": 6290,
	"./Editor/right-indent-01.svg": 42383,
	"./Editor/roller-brush.svg": 74591,
	"./Editor/scale-01.svg": 65814,
	"./Editor/scale-02.svg": 95125,
	"./Editor/scale-03.svg": 33844,
	"./Editor/scissors-02.svg": 1004,
	"./Editor/skew.svg": 72286,
	"./Editor/strikethrough-01.svg": 47519,
	"./Editor/strikethrough-02.svg": 68492,
	"./Editor/subscript.svg": 31147,
	"./Editor/text-input.svg": 43030,
	"./Editor/transform.svg": 7156,
	"./Editor/type-01.svg": 20060,
	"./Editor/type-02.svg": 99087,
	"./Editor/underline-01.svg": 57904,
	"./Editor/underline-02.svg": 19395,
	"./Editor/zoom-in.svg": 5871,
	"./Editor/zoom-out.svg": 93594,
	"./Education/atom-01.svg": 99656,
	"./Education/award-02.svg": 6149,
	"./Education/award-03.svg": 28132,
	"./Education/award-04.svg": 76491,
	"./Education/award-05.svg": 71226,
	"./Education/beaker-02.svg": 25564,
	"./Education/book-closed.svg": 46621,
	"./Education/book-open-01.svg": 79371,
	"./Education/briefcase-01.svg": 33283,
	"./Education/briefcase-02.svg": 43888,
	"./Education/calculator.svg": 74827,
	"./Education/certificate-01.svg": 92936,
	"./Education/certificate-02.svg": 74299,
	"./Education/compass.svg": 497,
	"./Education/glasses-01.svg": 4299,
	"./Education/glasses-02.svg": 46232,
	"./Education/globe-slated-02.svg": 18405,
	"./Education/graduation-hat-02.svg": 34722,
	"./Education/microscope.svg": 10087,
	"./Education/ruler.svg": 7101,
	"./Education/stand.svg": 51277,
	"./Education/telescope.svg": 53173,
	"./Education/trophy-01.svg": 79423,
	"./Files/box.svg": 71693,
	"./Files/clipboard-attachment.svg": 106,
	"./Files/clipboard-check.svg": 28735,
	"./Files/clipboard-download.svg": 89445,
	"./Files/clipboard-minus.svg": 75523,
	"./Files/clipboard-plus.svg": 56069,
	"./Files/clipboard-x.svg": 37083,
	"./Files/clipboard.svg": 40348,
	"./Files/file-03.svg": 56018,
	"./Files/file-04.svg": 89949,
	"./Files/file-05.svg": 77756,
	"./Files/file-07.svg": 77854,
	"./Files/file-attachment-03.svg": 3328,
	"./Files/file-attachment-04.svg": 61887,
	"./Files/file-check-02.svg": 89842,
	"./Files/file-check-03.svg": 27779,
	"./Files/file-download-02.svg": 48832,
	"./Files/file-download-03.svg": 89393,
	"./Files/file-plus-02.svg": 54544,
	"./Files/file-plus-03.svg": 66785,
	"./Files/file-question-02.svg": 10928,
	"./Files/file-question-03.svg": 2049,
	"./Files/file-search-02.svg": 64996,
	"./Files/file-search-03.svg": 36069,
	"./Files/file-x-02.svg": 98254,
	"./Files/file-x-03.svg": 3007,
	"./Files/folder-check.svg": 20469,
	"./Files/folder-closed.svg": 99423,
	"./Files/folder-download.svg": 51475,
	"./Files/folder-lock.svg": 9310,
	"./Files/folder-minus.svg": 79773,
	"./Files/folder-plus.svg": 8847,
	"./Files/folder-question.svg": 97151,
	"./Files/folder-search.svg": 52099,
	"./Files/folder-x.svg": 30005,
	"./Files/folder.svg": 78342,
	"./Files/paperclip.svg": 86990,
	"./Finance & eCommerce/bank-note-01.svg": 23196,
	"./Finance & eCommerce/bank-note-03.svg": 23294,
	"./Finance & eCommerce/bank.svg": 46763,
	"./Finance & eCommerce/coins-01.svg": 1099,
	"./Finance & eCommerce/coins-02.svg": 66712,
	"./Finance & eCommerce/coins-hand.svg": 91505,
	"./Finance & eCommerce/coins-stacked-01.svg": 37427,
	"./Finance & eCommerce/coins-stacked-02.svg": 46688,
	"./Finance & eCommerce/credit-card-02.svg": 88328,
	"./Finance & eCommerce/cryptocurrency-01.svg": 60205,
	"./Finance & eCommerce/cryptocurrency-02.svg": 77230,
	"./Finance & eCommerce/cryptocurrency-03.svg": 91871,
	"./Finance & eCommerce/cryptocurrency-04.svg": 74400,
	"./Finance & eCommerce/currency-dollar-circle.svg": 78432,
	"./Finance & eCommerce/currency-dollar.svg": 21539,
	"./Finance & eCommerce/currency-euro-circle.svg": 80619,
	"./Finance & eCommerce/currency-euro.svg": 75822,
	"./Finance & eCommerce/currency-pound-circle.svg": 32542,
	"./Finance & eCommerce/currency-pound.svg": 1089,
	"./Finance & eCommerce/currency-ruble-circle.svg": 34842,
	"./Finance & eCommerce/currency-ruble.svg": 77581,
	"./Finance & eCommerce/currency-rupee-circle.svg": 46733,
	"./Finance & eCommerce/currency-rupee.svg": 9856,
	"./Finance & eCommerce/currency-yen-circle.svg": 68344,
	"./Finance & eCommerce/currency-yen.svg": 55323,
	"./Finance & eCommerce/diamond-01.svg": 99581,
	"./Finance & eCommerce/gift-01.svg": 16265,
	"./Finance & eCommerce/gift-02.svg": 71450,
	"./Finance & eCommerce/piggy-bank-01.svg": 2738,
	"./Finance & eCommerce/receipt-check.svg": 33912,
	"./Finance & eCommerce/receipt.svg": 53415,
	"./Finance & eCommerce/safe.svg": 95170,
	"./Finance & eCommerce/sale-01.svg": 96108,
	"./Finance & eCommerce/sale-02.svg": 75135,
	"./Finance & eCommerce/sale-03.svg": 46702,
	"./Finance & eCommerce/sale-04.svg": 45201,
	"./Finance & eCommerce/scales-01.svg": 70524,
	"./Finance & eCommerce/scales-02.svg": 49551,
	"./Finance & eCommerce/shopping-bag-01.svg": 13272,
	"./Finance & eCommerce/shopping-bag-02.svg": 52107,
	"./Finance & eCommerce/shopping-cart-01.svg": 91540,
	"./Finance & eCommerce/shopping-cart-03.svg": 23510,
	"./Finance & eCommerce/tag-01.svg": 2125,
	"./Finance & eCommerce/tag-02.svg": 73006,
	"./Finance & eCommerce/wallet-02.svg": 8857,
	"./General/activity-heart.svg": 72465,
	"./General/activity.svg": 4182,
	"./General/anchor.svg": 80150,
	"./General/archive.svg": 31865,
	"./General/asterisk-01.svg": 52947,
	"./General/asterisk-02.svg": 8288,
	"./General/at-sign.svg": 97328,
	"./General/bookmark-add.svg": 7215,
	"./General/bookmark-check.svg": 6658,
	"./General/bookmark.svg": 96637,
	"./General/building-02.svg": 77272,
	"./General/building-04.svg": 9542,
	"./General/building-05.svg": 97079,
	"./General/building-06.svg": 70308,
	"./General/building-07.svg": 25029,
	"./General/building-08.svg": 29858,
	"./General/check-circle-broken.svg": 20222,
	"./General/check-circle.svg": 17532,
	"./General/check-done-01.svg": 9284,
	"./General/check-done-02.svg": 13879,
	"./General/check-heart.svg": 94324,
	"./General/check-square-broken.svg": 94021,
	"./General/check-square.svg": 80933,
	"./General/check-verified-01.svg": 11640,
	"./General/check-verified-02.svg": 50475,
	"./General/check-verified-03.svg": 31418,
	"./General/check.svg": 95167,
	"./General/cloud-blank-01.svg": 95927,
	"./General/copy-01.svg": 26921,
	"./General/copy-02.svg": 78613,
	"./General/copy-03.svg": 17332,
	"./General/copy-04.svg": 48955,
	"./General/copy-05.svg": 6986,
	"./General/copy-06.svg": 32985,
	"./General/copy-07.svg": 67592,
	"./General/divide-02.svg": 35733,
	"./General/divide-03.svg": 63124,
	"./General/download-01-alt.svg": 8965,
	"./General/download-01.svg": 84139,
	"./General/download-02.svg": 45304,
	"./General/download-03.svg": 80169,
	"./General/download-cloud-01.svg": 87132,
	"./General/edit-01.svg": 43347,
	"./General/edit-02.svg": 98688,
	"./General/edit-03.svg": 96721,
	"./General/edit-04.svg": 85166,
	"./General/edit-05.svg": 16159,
	"./General/equal-not.svg": 63975,
	"./General/equal.svg": 46755,
	"./General/eye-off.svg": 92992,
	"./General/eye.svg": 59900,
	"./General/filter-funnel-01.svg": 79720,
	"./General/filter-funnel-02.svg": 30459,
	"./General/filter-lines.svg": 62921,
	"./General/google-chrome.svg": 8687,
	"./General/hash-01.svg": 44423,
	"./General/hash-02.svg": 96212,
	"./General/heart-circle.svg": 30808,
	"./General/heart-hand.svg": 79999,
	"./General/heart-rounded.svg": 94751,
	"./General/heart-square.svg": 46177,
	"./General/hearts.svg": 18322,
	"./General/help-circle.svg": 67917,
	"./General/help-hexagon.svg": 31039,
	"./General/help-octagon.svg": 94814,
	"./General/help-square.svg": 56768,
	"./General/home-01.svg": 7148,
	"./General/home-02.svg": 86175,
	"./General/home-03.svg": 48238,
	"./General/home-line.svg": 64463,
	"./General/info-circle.svg": 53714,
	"./General/info-hexagon.svg": 40598,
	"./General/info-octagon.svg": 54003,
	"./General/info-square.svg": 84567,
	"./General/life-buoy-01.svg": 94329,
	"./General/link-01.svg": 47483,
	"./General/link-02.svg": 66120,
	"./General/link-03.svg": 31513,
	"./General/link-broken-01.svg": 80411,
	"./General/link-broken-02.svg": 48520,
	"./General/link-external-01-alt.svg": 97683,
	"./General/link-external-01.svg": 53329,
	"./General/link-external-02.svg": 82434,
	"./General/loading-01.svg": 26297,
	"./General/loading-02.svg": 83946,
	"./General/loading-03.svg": 25915,
	"./General/log-in-01-alt.svg": 82043,
	"./General/log-in-01.svg": 26457,
	"./General/log-in-02-alt.svg": 44680,
	"./General/log-in-02.svg": 35082,
	"./General/log-in-03-alt.svg": 66165,
	"./General/log-in-04-alt.svg": 63346,
	"./General/log-out-01-alt.svg": 15288,
	"./General/log-out-01.svg": 47578,
	"./General/log-out-02-alt.svg": 61067,
	"./General/log-out-03-alt.svg": 87982,
	"./General/log-out-04-alt.svg": 99081,
	"./General/medical-circle.svg": 63851,
	"./General/medical-cross.svg": 17441,
	"./General/medical-square.svg": 23434,
	"./General/menu-01.svg": 82528,
	"./General/minus-circle.svg": 36032,
	"./General/minus-square.svg": 84649,
	"./General/minus.svg": 76899,
	"./General/percent-02.svg": 58527,
	"./General/percent-03.svg": 43886,
	"./General/pin-01.svg": 51894,
	"./General/pin-02.svg": 40117,
	"./General/placeholder.svg": 75136,
	"./General/plus-circle.svg": 32818,
	"./General/plus-square.svg": 15575,
	"./General/plus.svg": 39717,
	"./General/save-01.svg": 50458,
	"./General/search-md.svg": 74617,
	"./General/search-refraction.svg": 59347,
	"./General/search-sm.svg": 95462,
	"./General/settings-01.svg": 170,
	"./General/settings-04.svg": 56455,
	"./General/share-01-alt.svg": 97916,
	"./General/share-01.svg": 75654,
	"./General/share-02-alt.svg": 63183,
	"./General/share-04-alt.svg": 56549,
	"./General/share-05.svg": 54573,
	"./General/share-06.svg": 18889,
	"./General/share-07.svg": 43384,
	"./General/slash-circle-01.svg": 58727,
	"./General/slash-divider.svg": 88688,
	"./General/speedometer-01.svg": 87044,
	"./General/speedometer-03.svg": 36166,
	"./General/target-04.svg": 69247,
	"./General/target-05.svg": 40814,
	"./General/toggle-02-left.svg": 76274,
	"./General/toggle-02-right.svg": 77545,
	"./General/tool-01.svg": 21841,
	"./General/tool-02.svg": 41442,
	"./General/translate-01.svg": 5223,
	"./General/translate-02.svg": 57012,
	"./General/trash-01.svg": 92019,
	"./General/trash-02.svg": 31008,
	"./General/upload-01-alt.svg": 4592,
	"./General/upload-01.svg": 6053,
	"./General/upload-02.svg": 21569,
	"./General/upload-03.svg": 86032,
	"./General/upload-cloud-01.svg": 10494,
	"./General/virus.svg": 4244,
	"./General/x-circle.svg": 32760,
	"./General/x-close.svg": 72056,
	"./General/x-square.svg": 4129,
	"./General/zap-circle.svg": 61715,
	"./General/zap-fast.svg": 55853,
	"./General/zap-square.svg": 81362,
	"./General/zap.svg": 82678,
	"./Images/camera-01.svg": 89114,
	"./Images/camera-02.svg": 79606,
	"./Images/colors.svg": 60987,
	"./Images/flash.svg": 47571,
	"./Images/image-01.svg": 41910,
	"./Images/image-02.svg": 62197,
	"./Images/image-03.svg": 40564,
	"./Images/image-05.svg": 49450,
	"./Images/image-check.svg": 76629,
	"./Images/image-plus.svg": 98479,
	"./Images/image-user-check.svg": 25901,
	"./Images/image-user-plus.svg": 75271,
	"./Images/image-user-x.svg": 36637,
	"./Images/image-user.svg": 71182,
	"./Images/image-x.svg": 24661,
	"./Layout/align-bottom-01.svg": 38330,
	"./Layout/align-horizontal-centre-01.svg": 97879,
	"./Layout/align-left-01.svg": 90728,
	"./Layout/align-right-01.svg": 93837,
	"./Layout/align-top-01.svg": 26300,
	"./Layout/align-top-02.svg": 12271,
	"./Layout/align-vertical-center-01.svg": 89607,
	"./Layout/columns-01.svg": 88800,
	"./Layout/columns-02.svg": 65728,
	"./Layout/columns-03.svg": 80706,
	"./Layout/divider.svg": 57978,
	"./Layout/flex-align-left.svg": 6740,
	"./Layout/flex-align-right.svg": 45723,
	"./Layout/grid-01.svg": 35533,
	"./Layout/grid-02.svg": 3534,
	"./Layout/grid-03.svg": 15615,
	"./Layout/grid-dots-blank.svg": 97721,
	"./Layout/grid-dots-outer.svg": 53054,
	"./Layout/intersect-circle.svg": 74279,
	"./Layout/intersect-square.svg": 86102,
	"./Layout/layer-single.svg": 96871,
	"./Layout/layers-three-01.svg": 49082,
	"./Layout/layers-three-02.svg": 17193,
	"./Layout/layers-two-01.svg": 37560,
	"./Layout/layers-two-02.svg": 76395,
	"./Layout/layout-alt-01.svg": 80281,
	"./Layout/layout-alt-02.svg": 35882,
	"./Layout/layout-alt-03.svg": 53723,
	"./Layout/layout-alt-04.svg": 20660,
	"./Layout/layout-grid-01.svg": 14258,
	"./Layout/layout-grid-02.svg": 96001,
	"./Layout/layout-left.svg": 99385,
	"./Layout/layout-right.svg": 14244,
	"./Layout/layout-top.svg": 4115,
	"./Layout/list.svg": 58979,
	"./Layout/maximize-01.svg": 22763,
	"./Layout/maximize-02.svg": 72024,
	"./Layout/minimize-01.svg": 53401,
	"./Layout/rows-02.svg": 18175,
	"./Layout/rows-03.svg": 89742,
	"./Layout/spacing-height-01.svg": 81474,
	"./Layout/spacing-width-01.svg": 8239,
	"./Layout/table.svg": 93250,
	"./Maps & travel/bus.svg": 21940,
	"./Maps & travel/car-01.svg": 35064,
	"./Maps & travel/car-02.svg": 73899,
	"./Maps & travel/compass-03.svg": 85560,
	"./Maps & travel/flag-01.svg": 18632,
	"./Maps & travel/flag-02.svg": 53019,
	"./Maps & travel/flag-03.svg": 92650,
	"./Maps & travel/flag-06.svg": 91463,
	"./Maps & travel/globe-01.svg": 92931,
	"./Maps & travel/globe-02.svg": 31440,
	"./Maps & travel/globe-03.svg": 43681,
	"./Maps & travel/globe-04.svg": 34750,
	"./Maps & travel/globe-05.svg": 97327,
	"./Maps & travel/globe-06.svg": 18300,
	"./Maps & travel/luggage-03.svg": 59444,
	"./Maps & travel/map-01.svg": 54872,
	"./Maps & travel/map-02.svg": 89259,
	"./Maps & travel/marker-pin-01.svg": 51938,
	"./Maps & travel/marker-pin-05.svg": 81134,
	"./Maps & travel/marker-pin-06.svg": 64109,
	"./Maps & travel/navigation-pointer-01.svg": 85048,
	"./Maps & travel/navigation-pointer-02.svg": 43115,
	"./Maps & travel/plane.svg": 64356,
	"./Maps & travel/rocket-02.svg": 77165,
	"./Maps & travel/route.svg": 88897,
	"./Maps & travel/ticket-01.svg": 25842,
	"./Maps & travel/train.svg": 84016,
	"./Maps & travel/tram.svg": 16902,
	"./Maps & travel/truck-01.svg": 42001,
	"./Maps & travel/truck-02.svg": 87458,
	"./Media & devices/airplay.svg": 83970,
	"./Media & devices/airpods.svg": 24628,
	"./Media & devices/battery-charging-01.svg": 69163,
	"./Media & devices/battery-full.svg": 76487,
	"./Media & devices/battery-low.svg": 25414,
	"./Media & devices/bluetooth-connect.svg": 3859,
	"./Media & devices/bluetooth-on.svg": 88560,
	"./Media & devices/chrome-cast.svg": 95746,
	"./Media & devices/clapperboard.svg": 95961,
	"./Media & devices/disc-02.svg": 2194,
	"./Media & devices/fast-backward.svg": 6864,
	"./Media & devices/fast-forward.svg": 12650,
	"./Media & devices/film-01.svg": 88002,
	"./Media & devices/film-02.svg": 68401,
	"./Media & devices/film-03.svg": 27840,
	"./Media & devices/gaming-pad-01.svg": 83513,
	"./Media & devices/gaming-pad-02.svg": 57514,
	"./Media & devices/hard-drive.svg": 9760,
	"./Media & devices/headphones-01.svg": 78895,
	"./Media & devices/keyboard-01.svg": 82297,
	"./Media & devices/keyboard-02.svg": 21546,
	"./Media & devices/laptop-01.svg": 83624,
	"./Media & devices/laptop-02.svg": 64987,
	"./Media & devices/lightbulb-01.svg": 41591,
	"./Media & devices/lightbulb-02.svg": 98468,
	"./Media & devices/lightbulb-03.svg": 49637,
	"./Media & devices/microphone-01.svg": 91564,
	"./Media & devices/microphone-off-01.svg": 35936,
	"./Media & devices/modem-02.svg": 909,
	"./Media & devices/monitor-01.svg": 50362,
	"./Media & devices/monitor-03.svg": 14232,
	"./Media & devices/mouse.svg": 78705,
	"./Media & devices/music-note-01.svg": 5098,
	"./Media & devices/music-note-02.svg": 54393,
	"./Media & devices/pause-circle.svg": 73379,
	"./Media & devices/pause-square.svg": 33954,
	"./Media & devices/phone-01.svg": 26992,
	"./Media & devices/phone-02.svg": 16387,
	"./Media & devices/play-circle.svg": 74243,
	"./Media & devices/play-square.svg": 57858,
	"./Media & devices/play.svg": 20134,
	"./Media & devices/podcast.svg": 64876,
	"./Media & devices/power-01.svg": 74373,
	"./Media & devices/power-02.svg": 26246,
	"./Media & devices/printer.svg": 19764,
	"./Media & devices/recording-01.svg": 98535,
	"./Media & devices/recording-02.svg": 27028,
	"./Media & devices/repeat-01.svg": 54891,
	"./Media & devices/repeat-02.svg": 16056,
	"./Media & devices/repeat-03.svg": 75209,
	"./Media & devices/repeat-04.svg": 48326,
	"./Media & devices/rss-01.svg": 38152,
	"./Media & devices/rss-02.svg": 88891,
	"./Media & devices/shuffle-01.svg": 69813,
	"./Media & devices/signal-01.svg": 43448,
	"./Media & devices/signal-02.svg": 1515,
	"./Media & devices/signal-03.svg": 23994,
	"./Media & devices/simcard.svg": 38851,
	"./Media & devices/skip-back.svg": 86687,
	"./Media & devices/skip-forward.svg": 93337,
	"./Media & devices/sliders-01.svg": 28966,
	"./Media & devices/sliders-02.svg": 65189,
	"./Media & devices/sliders-03.svg": 87172,
	"./Media & devices/sliders-04.svg": 35531,
	"./Media & devices/speaker-01.svg": 71317,
	"./Media & devices/stop-circle.svg": 98205,
	"./Media & devices/tablet-01.svg": 62500,
	"./Media & devices/tablet-02.svg": 89271,
	"./Media & devices/tv-03.svg": 42720,
	"./Media & devices/usb-flash-drive.svg": 85284,
	"./Media & devices/video-recorder-off.svg": 22912,
	"./Media & devices/video-recorder.svg": 39036,
	"./Media & devices/voicemail.svg": 27675,
	"./Media & devices/volume-max.svg": 49811,
	"./Media & devices/volume-min.svg": 51365,
	"./Media & devices/volume-minus.svg": 87869,
	"./Media & devices/volume-plus.svg": 55471,
	"./Media & devices/volume-x.svg": 59349,
	"./Media & devices/webcam-01.svg": 8225,
	"./Media & devices/webcam-02.svg": 42834,
	"./Media & devices/wifi-off.svg": 20871,
	"./Media & devices/wifi.svg": 19567,
	"./Media & devices/youtube.svg": 55891,
	"./Security/face-id-square.svg": 55846,
	"./Security/face-id.svg": 10186,
	"./Security/file-lock-02.svg": 53562,
	"./Security/file-lock-03.svg": 58827,
	"./Security/file-shield-02.svg": 36728,
	"./Security/file-shield-03.svg": 71593,
	"./Security/fingerprint-03.svg": 59821,
	"./Security/folder-shield.svg": 80803,
	"./Security/key-01.svg": 536,
	"./Security/key-02.svg": 55723,
	"./Security/lock-01.svg": 7022,
	"./Security/lock-03.svg": 42636,
	"./Security/lock-keyhole-circle.svg": 24447,
	"./Security/lock-unlocked-01.svg": 92416,
	"./Security/lock-unlocked-03.svg": 8002,
	"./Security/passcode-lock.svg": 96869,
	"./Security/passcode.svg": 11607,
	"./Security/scan.svg": 56776,
	"./Security/shield-01.svg": 38412,
	"./Security/shield-dollar.svg": 78427,
	"./Security/shield-off.svg": 56404,
	"./Security/shield-plus.svg": 55449,
	"./Security/shield-tick.svg": 3986,
	"./Security/shield-zap.svg": 23970,
	"./Shapes/circle.svg": 55835,
	"./Shapes/cube-01.svg": 54196,
	"./Shapes/cube-03.svg": 54934,
	"./Shapes/cube-04.svg": 30169,
	"./Shapes/hexagon-01.svg": 27463,
	"./Shapes/hexagon-02.svg": 55956,
	"./Shapes/octagon.svg": 92944,
	"./Shapes/pentagon.svg": 52443,
	"./Shapes/square.svg": 29914,
	"./Shapes/star-01.svg": 59437,
	"./Shapes/star-02.svg": 76462,
	"./Shapes/star-03.svg": 91103,
	"./Shapes/star-04.svg": 73632,
	"./Shapes/star-05.svg": 88017,
	"./Shapes/star-06.svg": 30914,
	"./Shapes/triangle.svg": 80231,
	"./Time/alarm-clock-check.svg": 50001,
	"./Time/alarm-clock.svg": 61410,
	"./Time/calendar-check-01.svg": 43463,
	"./Time/calendar-check-02.svg": 55604,
	"./Time/calendar-date.svg": 35511,
	"./Time/calendar.svg": 40914,
	"./Time/clock-check.svg": 94593,
	"./Time/clock-refresh.svg": 29456,
	"./Time/clock-stopwatch.svg": 93020,
	"./Time/clock.svg": 82194,
	"./Time/hourglass-01.svg": 51150,
	"./Time/hourglass-03.svg": 556,
	"./Time/watch-circle.svg": 4774,
	"./Time/watch-square.svg": 99515,
	"./Users/face-frown.svg": 12857,
	"./Users/face-happy.svg": 93163,
	"./Users/face-neutral.svg": 90008,
	"./Users/face-smile.svg": 6397,
	"./Users/user-01.svg": 62892,
	"./Users/user-check-02.svg": 86670,
	"./Users/user-circle.svg": 29405,
	"./Users/user-down-02.svg": 76420,
	"./Users/user-edit.svg": 47081,
	"./Users/user-left-02.svg": 4217,
	"./Users/user-minus-02.svg": 77458,
	"./Users/user-plus-02.svg": 24428,
	"./Users/user-right-02.svg": 11636,
	"./Users/user-up-02.svg": 72029,
	"./Users/user-x-02.svg": 90114,
	"./Users/users-01.svg": 14717,
	"./Users/users-03.svg": 4271,
	"./Weather/cloud-01.svg": 61268,
	"./Weather/cloud-02.svg": 49127,
	"./Weather/cloud-lightning.svg": 29497,
	"./Weather/cloud-moon.svg": 38370,
	"./Weather/cloud-raining-04.svg": 21930,
	"./Weather/cloud-raining-05.svg": 90747,
	"./Weather/cloud-snowing-02.svg": 18968,
	"./Weather/cloud-sun-01.svg": 1499,
	"./Weather/cloud-sun-02.svg": 85960,
	"./Weather/droplets-01.svg": 51660,
	"./Weather/hurricane-01.svg": 94690,
	"./Weather/hurricane-02.svg": 35441,
	"./Weather/lightning-01.svg": 56891,
	"./Weather/lightning-02.svg": 25000,
	"./Weather/moon-01.svg": 90470,
	"./Weather/moon-02.svg": 89605,
	"./Weather/moon-star.svg": 22587,
	"./Weather/snowflake-01.svg": 25405,
	"./Weather/snowflake-02.svg": 71230,
	"./Weather/stars-01.svg": 38352,
	"./Weather/stars-02.svg": 95395,
	"./Weather/sun-setting-01.svg": 45954,
	"./Weather/sun-setting-02.svg": 3057,
	"./Weather/sun.svg": 61377,
	"./Weather/umbrella-02.svg": 37556,
	"./Weather/umbrella-03.svg": 82485,
	"./Weather/waves.svg": 72561,
	"./Weather/wind-01.svg": 48025,
	"./Weather/wind-02.svg": 82378,
	"./Weather/wind-03.svg": 51195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46069;